import { FC, useMemo } from 'react';
import tradingStore from './store';
import TradingContext from './context';

const TradingContextProvider: FC<{ children: any }> = ({ children }) => {
  const formValuesContext = useMemo(
    () => ({
      tradingStore: tradingStore(),
    }),
    [],
  );

  return (
    <TradingContext.Provider value={formValuesContext}>
      {children}
    </TradingContext.Provider>
  );
};

export default TradingContextProvider;
